/**
 * @description 解决 Ajax 请求头问题，因为有些方法直接使用的 $.post 无法添加请求头，因此，直接在此处处理
 * @param {string} url
 * @param {object} headers
 * @param {object} data
 * @param {string} contentType
 * @param {function} success
 * @param {function} error
 */

export function ajaxWithHeaders({ url, headers = {}, data = {}, type = "POST", contentType, success, error }) {
	$.ajax({
		url: url,
		headers: headers,
		data: JSON.stringify(data),
		type: type,
		contentType: contentType || "application/json;charset=UTF-8",
		success: function (d) {
			if (success && typeof success === "function") success(d);
		},
		error: function (e) {
			if (error && typeof error === "function") error(e);
		},
	});
}
